<template>
  <figure class="c-embed">
    <header v-if="title" class="c-embed_header">
      <h3 class="c-embed_title">{{title}}</h3>
    </header>
    <div ref="embedElement" class="c-embed__content" :style="embedContentStyles" />
    <figcaption class="c-embed_credit" v-if="credit" v-html="credit" />
  </figure>
</template>

<script>
import PrismicDOM from 'prismic-dom'

export default {
  name: 'content-embed',
  props: ['content'],
  computed: {
    oEmbedScript () {
      return this.content.primary.oembed.html
    },
    hypeScript () {
      return this.content.primary.hype_script
    },
    embedType () {
      return this.content.primary.type
    },
    title () {
      return this.content.primary.title ? this.getTextContent(this.content.primary.title) : null
    },
    credit () {
      return this.content.primary.credit ? this.getHtmlContent(this.content.primary.credit) : null
    },
    embedContentStyles () {
      if (this.content.primary.hype_embed_width) {
        return {
          maxWidth: `${this.content.primary.hype_embed_width}px`
        }
      }
    }
  },
  methods: {
    generateHtmlFromStr (str) {
      return document.createRange().createContextualFragment(str)
    },
    renderEmbed (embed) {
      let html = this.generateHtmlFromStr(embed)
      this.$refs.embedElement.appendChild(html)
    },
    getTextContent (str) {
      return str ? PrismicDOM.RichText.asText(str) : ''
    },
    getHtmlContent (str) {
      return str ? PrismicDOM.RichText.asHtml(str, this.linkResolver) : ''
    }
  },
  mounted () {
    if (this.embedType === 'oEmbed') {
      this.renderEmbed(this.oEmbedScript)
    } else if (this.embedType === 'Hype') {
      this.renderEmbed(this.hypeScript)
    }
  }
}
</script>

<style lang="scss">
  .hype {
    position: relative;

    > div {
      z-index: z('hype-embed');
    }
  }

  .c-embed {}

  .c-embed_header {
    max-width: $content-width;
    margin: 0 auto;
  }

  .c-embed_title {
    text-align: center;
  }

  .c-embed__content {
    width: 100%;
    margin: 0 auto;
  }

  .c-embed_credit {
    padding: 5px;
    font-style: italic;
    font-size: .9rem;
    text-align: center;
  }
  .post-content--infographic .c-embed__content {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// Embed.vue?d79e69da